// UserContext.js
import React, {createContext, useContext, useState, useEffect} from 'react';
import {onSnapshot, query, where, collection} from "firebase/firestore";
import {getFirestore, Timestamp} from "firebase/firestore";
import moment from 'moment-timezone';
import {useUser} from "../UserContext.js";

const TraderContext = createContext();
export const useTrader = () => {

  return useContext(TraderContext);
};

export const TraderProvider = ({children}) => {
  const [requests, setRequests] = useState([]);
  const [allowedNo20PercentLimit, setAllowedNo20PercentLimit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isHoliday, setIsHoliday] = useState(false);
  const {appUser} = useUser();

  useEffect(() => {
    if (appUser && appUser.account !== "") {
      const currentDate = new Date();
      const dateTimeBefore24Hours = new Date(currentDate.getTime() - (24 * 60 * 60 * 1000));
      const db = getFirestore();
      const requestsQuery = query(collection(db, "requests"), where("created", ">", Timestamp.fromDate(dateTimeBefore24Hours)));
      const unsubscribe = onSnapshot(requestsQuery, (snapshot) => {
        const allDocuments = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
        const filtered = allDocuments.filter(doc => doc.account === appUser.account);
        const ordered = filtered.sort((a, b) => {
          return b.created - a.created;
        });
        // noneed to check forchanges, just set allDocuments
        setRequests(ordered);
      });

      return unsubscribe;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUser]);

  useEffect(() => {
    function setPeriodicChecks() {
      const now = moment.tz("America/New_York");
      const start = moment.tz("America/New_York").set({hour: 8, minute: 30, second: 0});
      const free = moment.tz("America/New_York").set({hour: 15, minute: 0, second: 0});
      const close = moment.tz("America/New_York").set({hour: 16, minute: 0, second: 0});
      const weekDay = now.day();
      if (weekDay === 0 || weekDay === 6) {
        ////////
        /// Fix me opposite
        ////////
        setIsOpen(false);
        setIsHoliday(true);
        setAllowedNo20PercentLimit(false);
        clearInterval(intervalId);
        return;
      } else {
        setIsHoliday(false);
        if (now > start && now < close) {
          setIsOpen(true);
        } else {
          setIsOpen(false);
        }
        if (now > free && now < close) {
          setAllowedNo20PercentLimit(true);
        } else {
          setAllowedNo20PercentLimit(false);
        }
      }
    }

    const intervalId = setInterval(setPeriodicChecks, 1000); // Update every second
    setPeriodicChecks();

    // Clear timeout if component unmounts before timeout completes
    return () => clearInterval(intervalId);
  }, []);

  // context returns
  // requests: array of all users' requests
  // allowedNo20PercentLimit: boolean if user is allowed to submit a request without 20% limit
  // isOpen: boolean if current time is between 12:30PM and 8:00PM
  const value = {
    requests,
    allowedNo20PercentLimit,
    isOpen,
    isHoliday
  };

  return <TraderContext.Provider value={value}>{children}</TraderContext.Provider>;
};
